import { gql } from '@apollo/client';

export default gql`
  query shopVersions($id: ID!, $klass: String!, $first: Int, $after: String, $filters: ActivityFilterInput) {
    shopVersions(id: $id, klass: $klass, first: $first, after: $after, filters: $filters) {
      nodes {
        id
        itemId
        itemType
        affectedObject
        eventVerb
        eventSubject
        createdAt
        user
        changes
        groupedCount
      }
      pageInfo {
        hasNextPage
        endCursor
        totalCount
      }
    }
  }
`;
